import { landing } from './landing.js'
import { login } from './login.js'
import { dashboard } from './dashboard.js'
import { bookings } from './bookings.js'
import { bookingsPublic } from './bookingsPublic.js'
import { cases } from './cases.js'
import { clients } from './clients.js'
import { documents } from './documents.js'
import { billing } from './billing.js'
import { aiAssistant } from './aiAssistant.js'
import { settingsPage } from './settingsPage.js'
import { clientPortal } from './clientPortal.js'
import { clientDashboard } from './clientDashboard.js'
import { pitch } from './pitch.js'
import { lawyers } from './lawyers.js'
import { profile } from './profile.js'
import { chat } from './chat.js'
import { forLawyers } from './forLawyers.js'
import { forClients } from './forClients.js'

export default {
  '/': landing,
  '/login': login,
  '/dashboard': dashboard,
  '/bookings': bookings,
  '/bookings/public': bookingsPublic,
  '/cases': cases,
  '/clients': clients,
  '/documents': documents,
  '/billing': billing,
  '/ai': aiAssistant,
  '/settings': settingsPage,
  '/client': clientPortal,
  '/client-dashboard': clientDashboard,
  '/pitch': pitch,
  '/lawyers': lawyers,
  '/lawyer': profile,
  '/firm': profile,
  '/chat': chat,
  '/for-lawyers': forLawyers,
  '/for-clients': forClients
}
